import { ReqBodyType } from '../types/reqBody';
import HttpClient from '../utils/HttpClient';

interface LinesServiceInterface {
  codUsu?: number;
  perfilUsu?: number;
  codEmpresa?: number;
  token: string;
  codLinhaSis?: string;
  usuario?: string;
  routeId?: string;
  reqBody?: ReqBodyType;
}

class LinesService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  listLines = async ({
    codUsu,
    perfilUsu,
    codEmpresa,
    token,
  }: LinesServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_CadLinhasFreta?codEmpresa=${codEmpresa}&codUsu=${codUsu}&perfilusu=${perfilUsu}`,
    });
  };

  getLine = async ({
    codUsu,
    perfilUsu,
    codLinhaSis,
    codEmpresa,
    token,
  }: LinesServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_LinhasFretaAcao?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codLinhaSis=${codLinhaSis}&codEmpresa=${codEmpresa}`,
    });
  };

  getOperators = async ({
    codEmpresa,
    codUsu,
    perfilUsu,
    token,
  }: LinesServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_CadLinhasFretaAlt?codEmpresa=${codEmpresa}&codUsu=${codUsu}&perfilUsu=${perfilUsu}`,
    });
  };

  createLine = async ({
    codUsu,
    perfilUsu,
    usuario,
    codEmpresa,
    token,
    reqBody,
  }: LinesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_CadLinhasFreta?codUsu=${codUsu}&perfilUsu=${perfilUsu}&usuario=${usuario}&codEmpresa=${codEmpresa}`,
      reqBody,
    });
  };

  updateLine = async ({
    codEmpresa,
    codUsu,
    perfilUsu,
    codLinhaSis,
    token,
    reqBody,
  }: LinesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_CadLinhasFretaAlt?codEmpresa=${codEmpresa}&codUsu=${codUsu}&perfilUsu=${perfilUsu}&codLinhaSis=${codLinhaSis}`,
      reqBody,
    });
  };

  deleteLine = async ({
    codUsu,
    perfilUsu,
    usuario,
    codEmpresa,
    token,
    codLinhaSis,
    routeId,
  }: LinesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_LinhasFretaAcao?codUsu=${codUsu}&perfilUsu=${perfilUsu}&usuario=${usuario}&codLinhaSis=${codLinhaSis}&routeID=${routeId}&codEmpresa=${codEmpresa}`,
    });
  };

  postShape = async ({
    codUsu,
    usuario,
    routeId,
    perfilUsu,
    codEmpresa,
    token,
    reqBody,
  }: LinesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_LinhaFretaMapa?codUsu=${codUsu}&usuario=${usuario}&routeID=${routeId}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}`,
      reqBody,
    });
  };

  getMapShape = async ({
    codUsu,
    perfilUsu,
    usuario,
    routeId,
    codEmpresa,
    token,
  }: LinesServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_LinhaFretaMapa?codUsu=${codUsu}&perfilUsu=${perfilUsu}&usuario=${usuario}&codEmpresa=${codEmpresa}&routeID=${routeId}`,
    });
  };
}

export default new LinesService();
